import React from 'react';

interface FieldErrorProps {
    message: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ message }) => {
    if (!message) return null;
    return <span className="cf-field-error">{message}</span>;
};

export default FieldError;
